<template>
  <el-dialog
    title="Oops! Tài khoản hết hạn"
    top="6vh"
    :visible.sync="modalShow"
    center
    append-to-body
    modal-append-to-body
  >
    <h4 style="word-break: break-word;" class="mt-2">
      Tài khoản của bạn đã hết hạn và không thể sử dụng các tính năng của Salework Zalo, vui lòng nâng cấp tài khoản để
      tiếp
      tục sử dụng.
    </h4>
    <div class="d-flex justify-content-center mt-3">
      <el-button type="primary" @click="newTab('https://salework.net/billing/service-subscriptions')">Nâng cấp tài
        khoản
      </el-button>

    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ExpiredBanner",
  data() {
    return {
      modalShow: true
    };
  }
};
</script>

<style scoped>

</style>
